import { simpleDate } from 'lib/date';
import { capitalize } from 'lib/util';
import ImportedPatient from 'models/ImportedPatient';
import { useCoordinatePatientsStore } from 'stores/patientFiltersStore';

import CoordinateListItem, { CoordinateListItemField } from './CoordinateListItem';

function buildFields(patient: ImportedPatient): CoordinateListItemField[] {
  return [
    patient.externalId && { label: 'ID', value: patient.externalId },
    patient.dateOfBirth && { label: 'DOB', value: simpleDate(patient.dateOfBirth) ?? '' },
    patient.sex && { label: 'Gender', value: capitalize(patient.sex) },
    patient.transferredFrom?.name && { label: 'Hospital', value: patient.transferredFrom.name },
  ].filter((field): field is CoordinateListItemField => Boolean(field));
}

function PatientList({
  patients,
  onAddToPortfolio,
}: {
  patients: ImportedPatient[];
  onAddToPortfolio?: (value: string) => void;
}) {
  const { search } = useCoordinatePatientsStore();
  return (
    <>
      {patients.map((patient) => (
        <CoordinateListItem
          key={`${patient.id}-${search}`}
          id={patient.id}
          name={patient.name}
          fields={buildFields(patient)}
          hasPendingRequest={patient.hasPendingRequest}
          onAddToPortfolio={onAddToPortfolio}
        />
      ))}
    </>
  );
}

export default PatientList;
